import { render, staticRenderFns } from "./EquipeForm.vue?vue&type=template&id=82476a0c&"
import script from "./EquipeForm.vue?vue&type=script&lang=js&"
export * from "./EquipeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports